export default __webpack_public_path__ + "static/media/lp-2024.50d0cca3.png";